<template>
  <span class="text-blue-grey subtitle">
    <QIcon
      name="ion-ios-people"
      size="14px"
    />
    {{ suffix(followerCount) }}
    <StreemTooltip>{{ tooltipText }}</StreemTooltip>

    <strong v-if="displaySeparator"><Bullet /></strong>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { Bullet } from "shared/components/base";
import { prettyNumber, suffix } from "shared/helpers/number";

interface SocialMentionCardFollowerProps {
  followerCount: number;
  displaySeparator?: boolean;
}

const props = defineProps<SocialMentionCardFollowerProps>();

const tooltipText = computed(() =>
  getLocaleText("social_mention_card_follower_count.follower_count", {
    followerCount: prettyNumber(props.followerCount),
  })
);
</script>

<style lang="scss" scoped>
.q-icon {
  vertical-align: 0;
}
</style>
